(function ($) {


    window.Cubes = {

        resize: function () {

            $('.cubeRow').each(function (row, rowitem) {
                if ($(this).hasClass('row-height')) {
                    var rowHt = $(this).height();
                }
                $('.so-panel', this).each(function (col, colitem) {
                    if ($(this).has('.cube').length) {
                        var ch = rowHt ? rowHt : $('.cube', this).height();
                        $('.cube,.face-1,.face-4,.face-5,.face-6', this).css({'height': ch});
                        var cubeD = 150;
                        var cubeW = $('.cube', this).width();
                        var cubeH = ch;
                        $('.face-3', this).css({'transform': 'rotateX(-90deg) translate3d(0, 0, ' + (cubeH - cubeD / 2 ) + 'px)'});
                        $('.face-5', this).css({'transform': 'rotateY(90deg) translate3d(0, 0,' + cubeW + 'px)'});
                    }
                });
            });
        },
        load: function () {

            var h = $(window).height();
            var n = 0;

            $('.cubeRow').each(function (row, rowitem) {

                if ($(this).hasClass('row-height')) {
                    var rowHt = $(this).height();
                }

                $('.so-panel', this).each(function (col, colitem) {

                    if ($(this).has('.cube').length) {
                        n++;

                        $(this).prepend('<div class="trigger-' + n + '" />');

                        var ch = rowHt ? rowHt : $('.cube', this).height();

                        var wrap = $('<div class="cube-wrap"></div>').addClass('cube-' + n).css({'height': ch});

                        if ($('.cube', this).hasClass('cube-left')) {
                            wrap.addClass('cube-left');
                        }
                        if ($('.cube', this).hasClass('cube-right')) {
                            wrap.addClass('cube-right');
                        }
                        if ($('.cube', this).hasClass('cube-up')) {
                            wrap.addClass('cube-up');
                        }
                        if ($('.cube', this).hasClass('cube-down')) {
                            wrap.addClass('cube-down');
                        }

                        if ($('.cube', this).hasClass('cube-sm')) {
                            wrap.addClass('cube-sm');
                        }
                        if ($('.cube', this).hasClass('cube-lg')) {
                            wrap.addClass('cube-lg');
                        }


                        wrap.append(
                            '<div class="face face-1"/>' +
                            '<div class="face face-2"/>' +
                            '<div class="face face-3"/>' +
                            '<div class="face face-4"/>' +
                            '<div class="face face-5"/>' +
                            '<div class="face face-6"/>');

                        $('.cube', this).wrap(wrap);


                        var controller = new ScrollMagic.Controller();
                        $('.cubeRow.stagger .so-panel .cube-wrap.cube-' + n).css({'transition-delay': col * 200 + 'ms'});
                        var scene = new ScrollMagic.Scene({
                            triggerElement: '.trigger-' + n,
                            triggerHook: 'onEnter',
                            offset: 250
                        }).setClassToggle('.cubeRow .so-panel .cube-wrap.cube-' + n, 'in')
                            .addTo(controller);
                    }
                });
            });


            $('.slideRow').each(function (row, rowitem) {

                if ($(this).hasClass('row-height')) {
                    var rowHt = $(this).height();
                }

                $('.so-panel', this).each(function (col, colitem) {

                    if ($(this).has('.slide').length) {

                        n++;

                        $(this).prepend('<div class="trigger-' + n + '" />');

                        var wrap = $('<div class="slide-wrap"></div>').addClass('slide-' + n);

                        if ($('.slide', this).hasClass('slide-up')) {
                            wrap.addClass('slide-up');
                        }
                        $('.slide', this).wrap(wrap);

                        var controller = new ScrollMagic.Controller();

                        var scene = new ScrollMagic.Scene({
                            triggerElement: '.trigger-' + n,
                            triggerHook: 'onEnter',
                            offset: 250
                        }).setClassToggle('.slideRow .so-panel .slide-wrap.slide-' + n, 'in')
                            .addTo(controller);
                    }

                });
            });

            $(window).on('resize', this.resize);
            this.resize();
        }

    };

})(jQuery); // Fully reference jQuery after this point.


/*
 function cubeResize() {
 //console.log();

 $('.cubeRow').each(function (row, rowitem) {
 if ($(this).hasClass('row-height')) {
 var rowHt = $(this).height();
 }
 $('.so-panel', this).each(function (col, colitem) {
 if ($(this).has('.cube').length) {

 var ch = rowHt ? rowHt : $('.cube', this).height();

 $('.cube,.face-1,.face-4,.face-5,.face-6', this).css({'height': ch});

 var cubeD = 150;
 var cubeW = $('.cube', this).width();
 var cubeH = ch;
 $('.face-3', this).css({'transform': 'rotateX(-90deg) translate3d(0, 0, ' + (cubeH - cubeD / 2 ) + 'px)'});
 $('.face-5', this).css({'transform': 'rotateY(90deg) translate3d(0, 0,' + cubeW + 'px)'});
 }
 });
 });
 }

 function loadCubes() {

 var h = $(window).height();
 var n = 0;

 $('.cubeRow').each(function (row, rowitem) {

 if ($(this).hasClass('row-height')) {
 var rowHt = $(this).height();
 }

 $('.so-panel', this).each(function (col, colitem) {

 if ($(this).has('.cube').length) {
 n++;

 $(this).prepend('<div class="trigger-' + n + '" />');

 var ch = rowHt ? rowHt : $('.cube', this).height();
 var wrap = $('<div class="cube-wrap"></div>').addClass('cube-' + n).css({'height': ch});

 if ($('.cube', this).hasClass('cube-left')) {
 wrap.addClass('cube-left');
 }
 if ($('.cube', this).hasClass('cube-right')) {
 wrap.addClass('cube-right');
 }
 if ($('.cube', this).hasClass('cube-up')) {
 wrap.addClass('cube-up');
 }
 if ($('.cube', this).hasClass('cube-down')) {
 wrap.addClass('cube-down');
 }

 if ($('.cube', this).hasClass('cube-sm')) {
 wrap.addClass('cube-sm');
 }
 if ($('.cube', this).hasClass('cube-lg')) {
 wrap.addClass('cube-lg');
 }

 wrap.append('<div class="face face-1"/><div class="face face-2"/><div class="face face-3"/><div class="face face-4"/><div class="face face-5"/><div class="face face-6"/>');

 $('.cube', this).wrap(wrap);

 var controller = new ScrollMagic.Controller();

 $('.cubeRow.stagger .so-panel .cube-wrap.cube-' + n).css({'transition-delay': col * 200 + 'ms'});

 var scene = new ScrollMagic.Scene({
 triggerElement: '.trigger-' + n,
 triggerHook: 'onEnter',
 offset: 250
 }).setClassToggle('.cubeRow .so-panel .cube-wrap.cube-' + n, 'in')
 .addTo(controller);
 }
 });
 });


 $('.slideRow').each(function (row, rowitem) {

 if ($(this).hasClass('row-height')) {
 var rowHt = $(this).height();
 }

 $('.so-panel', this).each(function (col, colitem) {

 if ($(this).has('.slide').length) {

 n++;

 $(this).prepend('<div class="trigger-' + n + '" />');

 var wrap = $('<div class="slide-wrap"></div>').addClass('slide-' + n);

 if ($('.slide', this).hasClass('slide-up')) {
 wrap.addClass('slide-up');
 }
 $('.slide', this).wrap(wrap);

 var controller = new ScrollMagic.Controller();

 var scene = new ScrollMagic.Scene({
 triggerElement: '.trigger-' + n,
 triggerHook: 'onEnter',
 offset: 250
 }).setClassToggle('.slideRow .so-panel .slide-wrap.slide-' + n, 'in')
 .addTo(controller);
 }

 });
 });

 $(window).on('resize', cubeResize);
 cubeResize();
 }

 */